"use strict";

(function () {
  var DEBOUNCE_MS = 150;
  var MIN_LENGTH = 2;
  var TYPE_LABELS = {
    article: "Artikkeli",
    category: "Kategoria",
  };

  function initInput(input, index) {
    var url = input.getAttribute("data-article-search-url");
    if (!url) return;

    var listbox = document.createElement("ul");
    listbox.className = "article-search__listbox";
    listbox.id = "article-search-listbox-" + index;
    listbox.setAttribute("role", "listbox");
    listbox.hidden = true;
    input.parentNode.appendChild(listbox);

    input.setAttribute("role", "combobox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-expanded", "false");
    input.setAttribute("aria-controls", listbox.id);

    var debounceTimer = null;
    var requestId = 0;
    var activeIndex = -1;
    var currentItems = [];

    function close() {
      listbox.hidden = true;
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
      activeIndex = -1;
    }

    function render(items) {
      currentItems = items;
      activeIndex = -1;
      input.removeAttribute("aria-activedescendant");
      listbox.innerHTML = "";

      if (!items.length) {
        close();
        return;
      }

      items.forEach(function (item, i) {
        var li = document.createElement("li");
        li.className = "article-search__option";
        if (item.type) {
          li.classList.add("article-search__option--" + item.type);
        }
        li.setAttribute("role", "option");
        li.id = listbox.id + "-option-" + i;

        var title = document.createElement("span");
        title.className = "article-search__option-title";
        title.textContent = item.title;
        li.appendChild(title);

        var label = TYPE_LABELS[item.type];
        if (label) {
          var typeLabel = document.createElement("span");
          typeLabel.className = "article-search__option-type";
          typeLabel.textContent = label;
          li.appendChild(typeLabel);
        }

        li.addEventListener("mousedown", function (event) {
          event.preventDefault();
          selectItem(item, i + 1);
        });
        listbox.appendChild(li);
      });

      listbox.hidden = false;
      input.setAttribute("aria-expanded", "true");
    }

    function setActive(i) {
      var options = listbox.querySelectorAll(".article-search__option");
      if (!options.length) return;

      if (i < 0) i = options.length - 1;
      if (i >= options.length) i = 0;
      activeIndex = i;

      options.forEach(function (opt, idx) {
        if (idx === i) {
          opt.classList.add("article-search__option--active");
          opt.setAttribute("aria-selected", "true");
          input.setAttribute("aria-activedescendant", opt.id);
        } else {
          opt.classList.remove("article-search__option--active");
          opt.removeAttribute("aria-selected");
        }
      });
    }

    function go(targetUrl) {
      if (targetUrl) window.location.href = targetUrl;
    }

    function selectItem(item, position) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "article_search",
        search_term: input.value.trim(),
        result_slug: item.slug,
        result_type: item.type,
        position: position,
      });
      go(item.url);
    }

    function fetchResults(term) {
      var thisRequest = ++requestId;
      fetch(url + "?q=" + encodeURIComponent(term), {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (response) {
          return response.ok ? response.json() : { results: [] };
        })
        .then(function (data) {
          if (thisRequest !== requestId) return;
          render(data.results || []);
        })
        .catch(function () {
          if (thisRequest !== requestId) return;
          close();
        });
    }

    input.addEventListener("input", function () {
      var term = input.value.trim();
      if (term.length < MIN_LENGTH) {
        close();
        return;
      }
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchResults(term);
      }, DEBOUNCE_MS);
    });

    input.addEventListener("keydown", function (event) {
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          setActive(activeIndex + 1);
          break;
        case "ArrowUp":
          event.preventDefault();
          setActive(activeIndex - 1);
          break;
        case "Enter":
          if (listbox.hidden) {
            break;
          }
          var selectedIndex = activeIndex >= 0 ? activeIndex : 0;
          var selected = currentItems[selectedIndex];
          if (selected) {
            event.preventDefault();
            selectItem(selected, selectedIndex + 1);
          }
          break;
        case "Escape":
          close();
          break;
      }
    });

    input.addEventListener("focus", function () {
      if (currentItems.length > 0 && listbox.hidden) {
        render(currentItems);
      }
    });

    input.addEventListener("blur", function () {
      setTimeout(close, 100);
    });

    document.addEventListener("click", function (event) {
      if (!input.parentNode.contains(event.target)) {
        close();
      }
    });
  }

  function init() {
    var inputs = document.querySelectorAll("input[data-article-search]");
    Array.prototype.forEach.call(inputs, initInput);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
